import React, { createContext, useContext, useState, useEffect } from 'react'
import { doLogout } from '../Localstorage';
import { useNavigate } from 'react-router-dom';
import { updateDeviceCount } from '../Firebase/User-fb';


const AccessCardContext = createContext();

export const Accesscardprovider = ({ children }) => {

    const navigate = useNavigate();
    const [card, setCard] = useState(false);
    const [pdf, setPdf] = useState(false);
    const [audio, setAudio] = useState(false);
    const [quiz, setQuiz] = useState(false);
    const [quizsubmit, setQuizsubmit] = useState(false);
    const [pcode, setPcode] = useState([]);
    const [acode, setAcode] = useState([]);
    const [vcode, setVcode] = useState([]);
    const [vicon, setVicon] = useState(null);
    const [qcode, setQcode] = useState([]);
    // const [topic, setTopic] = useState([]);
    const [question, setQuestion] = useState([]);
    const [open, setOpen] = useState(false);
    const [google,setGoogle] = useState(false);
    const [showCallReg, setShowCallReg] = useState(false);
    const [shouldLogout, setShouldLogout] = useState(false);
    const [loading, setLoading] = useState(true);
    const [marks, setMarks] = useState(0)
    const [head, setHead] = useState("");
    const [answer, setAnswer] = useState([])
    const [time, setTime] = useState(0);
    const [timeLeft, setTimeLeft] = useState(0);
    const [enroll, setEnroll] = useState([])
    const [showProfile, setShowProfile] = useState(false);
    const [quizCode, setQuizCode] = useState("");
    const [toast, setToast] = useState(null);

    useEffect(() => {
        setTimeLeft(time * 60);
    }, [time]);

    const toggleProfile = () => {
        setShowProfile(prev => !prev);
    };

    const accessCallReg = () => {
        setShowCallReg(!showCallReg);
    };

    const setEnrolData = (enroll) => {
        setEnroll(enroll);
    };

    const logoutUser = () => {
        doLogout(() => {
            setOpen(!open);
            setToast({ message: 'Logout Successful',type:'success'})
            setShouldLogout(!shouldLogout)
            navigate("/")
        });
    };

    const accessCard = () => {
        setCard(!card);
    }

    const accessPdfCard = () => {
        setPdf(!pdf);
    }

    const accessAudioCard = () => {
        setAudio(!audio);
    }

    const accessQuizCard = () => {
        setQuiz(!quiz);
    }

    const accessQuizSubmit = () => {
        setQuizsubmit(!quizsubmit)
    }

    const setQuestionData = (question_Data) => {
        if (!Array.isArray(question_Data)) {
            console.error("Invalid data: Expected an array", question_Data);
            return;
        }

        setQuestion(() => [...question_Data]);
    };

    const setTotalTime = (totalSeconds) => {
        setTime(totalSeconds);
    };

    const accessPcode = (pdfUrls) => {
        setPcode([]);
        pdfUrls.forEach((pdfUrl) => {
            setPcode((prev) => [...prev, pdfUrl])
        });
    };

    const accessAcode = (audioUrls) => {
        setAcode([]);
        audioUrls.forEach((audioUrl) => {
            setAcode((prev) => [...prev, audioUrl])
        });
    }

    const accessVcode = (videoUrls) => {
        setVcode([]);
        videoUrls.forEach((videoUrl) => {
            setVcode((prev) => [...prev, videoUrl])
        });
    }

    const accessQcode = (quizUrls) => {
        setQcode([]);
        quizUrls.forEach((quizUrl) => {
            setQcode((prev) => [...prev, quizUrl])
        })
    }


    return (
        <AccessCardContext.Provider value={{
            card, accessCard,
            pdf, accessPdfCard,
            pcode, accessPcode,
            audio, accessAudioCard,
            acode, accessAcode,
            vcode, accessVcode, setVcode,
            quiz, accessQuizCard,
            qcode, accessQcode,
            vicon, setVicon,
            // topic, setTopicData,
            showCallReg, accessCallReg,
            shouldLogout, setShouldLogout,
            open, setOpen,
            loading, setLoading,
            head, setHead,
            question, setQuestionData,
            quizsubmit, accessQuizSubmit,
            marks, setMarks, answer, setAnswer,
            timeLeft, setTimeLeft,
            toggleProfile, showProfile,
            time, setTotalTime, enroll, setEnrolData,
            quizCode, setQuizCode, toast, setToast, logoutUser,
            google,setGoogle
        }}>
            {children}
        </AccessCardContext.Provider>
    )
}

export const useAccessCard = () => useContext(AccessCardContext);